import React from 'react';
import ExtraInfo from '../components/ExtraInfo';

export default function ExtraInfoPage({ language }) {
  return (
    <main style={{padding: '2.5rem 0 1.5rem 0', background: '#f8fafd', minHeight: '80vh'}}>
      <ExtraInfo language={language} />
    </main>
  );
}
